<script setup lang="ts">
import ContentBanner from './Content/ContentBanner.vue'
</script>

<template>
    <div class="content-body">
        <slot name="contentBodyHead">
            <div class="content-body__head">
                <div class="content-body__exam">
                    <slot name="contentBodyExam" />
                </div>
                <div class="content-body__title">
                    <slot name="contentBodyTitle" />
                </div>
                <slot name="contentBodyFeedback">
                    <ContentBanner />
                </slot>
                <slot name="contentBodyBlob">
                    <img
                        class="content-body__blob"
                        src="@/assets/images/content-blue-blob.png"
                    >
                </slot>
                <div class="content-body__tabs">
                    <slot name="contentTabs" />
                </div>
                <div class="content-body__divider" />
                <div class="content-body__search">
                    <slot name="contentSearch" />
                </div>
                <div class="content-body__filter">
                    <slot name="contentFilter" />
                </div>
            </div>
        </slot>

        <div class="content-body__questions">
            <slot name="contentQuestions" />
        </div>
        <div class="content-body__pagination">
            <slot name="contentPagination" />
        </div>
    </div>
</template>

<style lang="scss" scoped>


.content-body {
    &__head {
        right: 0;
    }

    &__exam {
        color: $slate-01;
        margin-bottom: 24px;
        font-size: 14px;
        line-height: 19px;
    }

    &__title {
        font-size: 26px;
        line-height: 34px;
        font-weight: 600;
    }

    &__blob {
        position: absolute;
        right: 0;
        top: 180px;
        width: 223px;
        height: 95px;
    }

    &__divider {
        position: absolute;
        width: 55%;
        border: 0.5px solid $fog;
    }

    &__pagination {
        margin-bottom: 60px;
    }
}
</style>
